import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'projects/frontend/src/app/shared/services/store.service';

@Component({
    selector: 'app-thematic-areas',
    templateUrl: './thematic-areas.component.html',
    styleUrls: ['./thematic-areas.component.scss'],
    standalone: false
})
export class ThematicAreasComponent implements OnInit {

  authorityId = '';
  constructor(
    public storeService: StoreService,
    public translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.authorityId = this.storeService.codIpa;
  }

}
